import React from 'react';
import { any, bool } from 'prop-types';
import QueryManager from './Query';
import gql from 'graphql-tag';
import { get, map, filter, head, includes, groupBy, size, forEach, some, isEmpty } from 'lodash';

export const QUERY_GET_ORDER_ITEMS = gql`query getPickingInfoBy($id: String!) {
  getPickingInfoBy(orderId: $id) {
    results {
      ... on PickingProcess {
        pickingTime {
          stats {
              init
              end
              correlative
              field
          }
        }

        order {
          id
          windowAnticipated
          shippingChange
          items {
            id
            ean
            name
            imageUrl
            sku
            isUnit
            brandName
            listPrice
            split
            splitStatus
            quantity
            sellingPrice
            basePrice
            customerNotes
            refId
            unitMultiplier
            isGiftCencosud
            substitution {
              label
              code
            }
            priceTags {
              value
              rateAndBenefit {
                name
              }
            }
            unit
            isUpselling
          }
        }

        split
        emailSpliter
        nameSpliter
        eanSplitList

        removedItems {
          productId
          id
          sku
          status
          imageUrl
          refId
          ean
          price
          name
          brandName
          pickingQuantity
          unitMultiplier
          invoicePrice
          sellingPrice
          unit
          excess
        }
        weightError
        semaphore
        items {
          audits {
            decision
            codeRule
          }
          split
          splitStatus
          splitQuantity
          productId
          manualPicking
          id
          refId
          sku
          ean
          unpackaged
          price
          name
          brandName
          imageUrl
          status
          statusCode
          pickingQuantity
          unitMultiplier
          invoicePrice
          sellingPrice
          unit
          excess
          substitution {
            brandName
            sku
            manualPicking
            unpackaged
            ean
            price
            name
            imageUrl
            status
            unitMultiplier
            pickingQuantity
            invoicePrice
            sellingPrice
            excess
            unit
            refId
          }
        }

        auditInfo {
          failedCount
          passedCount
          rules
          results {
            failed {
              productId
              failed
              rules
              audits {
                codeRule
                decision
                value
              }
            }
          }
        }

      }
    }
  }
}
`;

const formatResponse = (response, withPicking, withoutAdded) => {


    const pickedItems = get(response, 'items', []);
    const removedItems = get(response, 'removedItems', []);
    const orderItems = get(response, 'order.items', []);
    const pickedItemsOutStock = filter(pickedItems, item => includes(['OUT_STOCK_ACCEPTED'], get(item, 'status')));
    const addedByClient = withoutAdded ? [] : filter(pickedItems, item => includes(['ADDED_BY_CLIENT'], get(item, 'status')));
    const outStocksWithoutAudit = filter(pickedItems, ({ audits, status }) => isEmpty(audits) && status === 'OUT_STOCK_ACCEPTED');
    const isUnpickedAndWasAdded = filter(removedItems, ({ id, status }) => !some(orderItems, ['id', id]) && includes(['UNPICK_BY_STORE'], status));
    let outStockFiltered = [];
    forEach(pickedItemsOutStock, item => {
        if (!some(orderItems, ['sku', get(item, 'sku')])) outStockFiltered = [...outStockFiltered, item];
    });
    let addedItems = [];
    forEach([...addedByClient], item => {
        const price = `${get(item, 'price', '000')}`;
        const listPrice = price.substring(0, size(price) - 2);
        addedItems = [...addedItems, {
            ...item,
            basePrice: listPrice,
            listPrice,
            quantity: get(item, 'pickingQuantity', 1)
        }];
    });
    
    const items = map(orderItems, ({ id, ...item }) => {
      return { id, picking: withPicking ? head(get(groupBy([...removedItems, ...pickedItems], 'id'), id)) : head(get(groupBy(removedItems, 'id'), id)), ...item };
    });

    const finalItems = [...items, ...addedItems];

    const results = {
        ...response,
        items: filter(finalItems, ({ id }) => !includes(Object.keys(groupBy(removedItems, 'id')), id)),
        removedItems: [...filter(finalItems, ({ id }) => includes(Object.keys(groupBy(removedItems, 'id')), id)), ...isUnpickedAndWasAdded],
        addedByClient: filter(finalItems, ({ id }) => includes(Object.keys(groupBy(addedByClient, 'id')), id)),
        isUnpickedAndWasAdded,
        outStocksWithoutAudit
    };

    return results;
};

const OrdersWithPicking = ({ children, data, refetch, loading, fetchMore }) => {
    return children({
        data,
        count: 1,
        refetch,
        loading
    });
};

const Orders = ({ children, withPicking, withoutAdded, ...props }) => {
    return (
        <QueryManager query={QUERY_GET_ORDER_ITEMS} {...props} fetchPolicy='no-cache'>
            {({ data, loading, fetchMore, refetch }) => {
                return (
                    <OrdersWithPicking
                        data={formatResponse(get(data, 'getPickingInfoBy.results.0', []), withPicking, withoutAdded)}
                        loading={loading}
                        fetchMore={fetchMore}
                        refetch={refetch}
                    >
                        {children}
                    </OrdersWithPicking>
                );
            }
      }
        </QueryManager>
    );
};

Orders.propTypes = {
    children: any,
    withPicking: bool,
    withoutAdded: bool
};

export default Orders;
